import styled from 'styled-components';
import { Radio } from 'antd';

export const StyledAppRadio = styled(Radio)`
  .ant-radio {
    align-self: start;
  }
  .ant-radio-label {
    margin-left: 5px;
  }
`;
